export default "__VITE_ASSET__BgYxfVqe__"